import { render, staticRenderFns } from "./AdvertsApprove.vue?vue&type=template&id=7e7149f0"
import script from "./AdvertsApprove.vue?vue&type=script&lang=js"
export * from "./AdvertsApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports